module.exports = __webpack_public_path__ + "img/25.aeb58616.jpg";